export const decideAvailable = (param_date) => {
    const cur_date = new Date();
    const input_date = new Date(param_date);
    if(cur_date >= input_date) {
        return 'green';
    } else {
        return 'red';
    }
}